import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import { type IoniconIconName } from "@/schemas/icons";

export enum ProfileScreenTab {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
  ABOUT = "ABOUT",
  MESSAGE = "MESSAGE",
}

type ProfileBodyProps = {
  selectedTab: ProfileScreenTab;
  setSelectedTab: (tab: ProfileScreenTab) => void;
};

type TabItem = {
  key: ProfileScreenTab;
  label: string;
  icon: IoniconIconName;
};

const tabs: TabItem[] = [
  {
    icon: "images-outline",
    key: ProfileScreenTab.PUBLIC,
    label: "Public",
  },
  {
    icon: "lock-closed-outline",
    key: ProfileScreenTab.PRIVATE,
    label: "Private",
  },
  {
    icon: "person",
    key: ProfileScreenTab.ABOUT,
    label: "About",
  },
  {
    icon: "chatbubble-ellipses-outline",
    key: ProfileScreenTab.MESSAGE,
    label: "Message",
  },
];

function ProfileTabs({
  selectedTab,
  setSelectedTab,
}: ProfileBodyProps): React.JSX.Element {
  return (
    <View style={styles.container}>
      <View style={styles.tabBar}>
        {tabs.map((tab) => {
          const isSelected = selectedTab === tab.key;
          return (
            <TouchableOpacity
              key={tab.key}
              style={styles.tabItem}
              onPress={() => setSelectedTab(tab.key)}
              accessibilityRole="tab"
              accessibilityState={{ selected: isSelected }}
            >
              <Ionicons
                name={tab.icon}
                size={24}
                color={
                  isSelected
                    ? "rgba(255, 255, 255, 0.95)"
                    : "rgba(255, 255, 255, 0.7)"
                }
              />
              <Text
                style={[styles.tabLabel, isSelected && styles.selectedTabLabel]}
              >
                {tab.label}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  selectedTabLabel: {
    color: "rgba(255, 255, 255, 0.95)",
    fontWeight: "bold",
  },
  tabBar: {
    flexDirection: "row",
    paddingHorizontal: 16,
  },
  tabItem: {
    alignItems: "center",
    flex: 1,
    paddingVertical: 12,
    position: "relative",
  },
  tabLabel: {
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: 12,
    marginTop: 4,
  },
});

export default ProfileTabs;
